export default __webpack_public_path__ + "static/inline-dialog.dark-cc8cb72a18ff0a0ceee63a80e3e77c868788f649117d63885fb6a66349bd46d7.png";